import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../utils/api';
import { TruckIcon } from '@heroicons/react/24/outline';

const KargonomiSettings = () => {
    const [settings, setSettings] = useState({
        enabled: false,
        apiToken: '',
        testMode: true
    });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    // Ayarları yükle
    useEffect(() => {
        loadSettings();
    }, []);

    const loadSettings = async () => {
        setLoading(true);
        try {
            const response = await api.get('/api/settings');
            const kargonomiSettings = response.kargonomiSettings || {
                enabled: false,
                apiToken: '',
                testMode: true
            };
            setSettings(kargonomiSettings);
        } catch (error) {
            console.error('Kargonomi ayarları yüklenirken hata:', error);
            toast.error('Ayarlar yüklenemedi');
        } finally {
            setLoading(false);
        }
    };

    const saveSettings = async () => {
        setSaving(true);
        try {
            const response = await api.get('/api/settings');
            const updatedSettings = {
                ...response,
                kargonomiSettings: settings
            };
            
            await api.put('/api/settings', updatedSettings);
            toast.success('Kargonomi ayarları kaydedildi');
        } catch (error) {
            console.error('Kargonomi ayarları kaydedilirken hata:', error);
            toast.error('Ayarlar kaydedilemedi');
        } finally {
            setSaving(false);
        }
    };

    const updateSetting = (field, value) => {
        setSettings(prev => ({
            ...prev,
            [field]: value
        }));
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center p-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto p-6">
            <div className="bg-white rounded-lg shadow-sm border">
                <div className="px-6 py-4 border-b border-gray-200">
                    <div className="flex items-center space-x-3">
                        <TruckIcon className="h-6 w-6 text-blue-600" />
                        <h2 className="text-xl font-semibold text-gray-900">Kargonomi API Ayarları</h2>
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                        Kargonomi entegrasyonunu yönetin
                    </p>
                </div>

                <div className="p-6 space-y-6">
                    {/* API Aktif/Pasif */}
                    <div>
                        <label className="flex items-center space-x-3">
                            <input
                                type="checkbox"
                                checked={settings.enabled}
                                onChange={(e) => updateSetting('enabled', e.target.checked)}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-900">
                                Kargonomi API'yi Aktif Et
                            </span>
                        </label>
                        <p className="text-xs text-gray-500 mt-1 ml-7">
                            Kapalı olduğunda mock sistem kullanılır
                        </p>
                    </div>

                    {/* API Token */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            API Token
                        </label>
                        <input
                            type="password"
                            value={settings.apiToken}
                            onChange={(e) => updateSetting('apiToken', e.target.value)}
                            placeholder="Kargonomi API Token'ınızı girin"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                        <p className="text-xs text-gray-500 mt-1">
                            Kargonomi hesabınızdan API token'ınızı alabilirsiniz
                        </p>
                    </div>

                    {/* Test Modu */}
                    <div>
                        <label className="flex items-center space-x-3">
                            <input
                                type="checkbox"
                                checked={settings.testMode}
                                onChange={(e) => updateSetting('testMode', e.target.checked)}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <span className="text-sm font-medium text-gray-900">
                                Test Modu
                            </span>
                        </label>
                        <p className="text-xs text-gray-500 mt-1 ml-7">
                            Test modunda gerçek kargo oluşturulmaz
                        </p>
                    </div>

                    {/* Durum Göstergesi */}
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <h4 className="text-sm font-medium text-gray-900 mb-2">Mevcut Durum</h4>
                        <div className="flex items-center space-x-2">
                            <div className={`w-3 h-3 rounded-full ${
                                settings.enabled && settings.apiToken 
                                    ? 'bg-green-500' 
                                    : 'bg-red-500'
                            }`}></div>
                            <span className="text-sm text-gray-600">
                                {settings.enabled && settings.apiToken 
                                    ? 'Kargonomi API Aktif' 
                                    : 'Mock Sistem Aktif'}
                            </span>
                        </div>
                        {settings.testMode && (
                            <div className="flex items-center space-x-2 mt-1">
                                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                                <span className="text-sm text-gray-600">Test Modu Aktif</span>
                            </div>
                        )}
                    </div>

                    {/* Kaydet Butonu */}
                    <div className="flex justify-end">
                        <button
                            onClick={saveSettings}
                            disabled={saving}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
                        >
                            {saving ? 'Kaydediliyor...' : 'Ayarları Kaydet'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KargonomiSettings;